import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { LoadingService } from './loading.service';

export class LoadingHelper {
    
    /**
     * Wraps an Observable with automatic loading state management
     * @param observable$ The Observable to wrap
     * @param loadingService The LoadingService instance
     * @returns The wrapped Observable with loading states
     */
    static withLoading<T>(observable$: Observable<T>, loadingService: LoadingService): Observable<T> {
        loadingService.show();
        
        return observable$.pipe(
            finalize(() => loadingService.hide())
        );
    }
    
    /**
     * Wraps an Observable with loading state and provides success/error callbacks
     * @param observable$ The Observable to wrap
     * @param loadingService The LoadingService instance
     * @param onSuccess Optional success callback
     * @param onError Optional error callback
     * @returns The wrapped Observable
     */
    static withLoadingAndCallbacks<T>(
        observable$: Observable<T>, 
        loadingService: LoadingService,
        onSuccess?: (data: T) => void,
        onError?: (error: any) => void
    ): Observable<T> {
        loadingService.show();
        
        return new Observable(subscriber => {
            observable$.pipe(
                finalize(() => loadingService.hide())
            ).subscribe({
                next: (data) => {
                    if (onSuccess) {
                        onSuccess(data);
                    }
                    subscriber.next(data);
                },
                error: (error) => {
                    if (onError) {
                        onError(error);
                    }
                    subscriber.error(error);
                },
                complete: () => {
                    subscriber.complete();
                }
            });
        });
    }
}